import { Component, OnInit } from '@angular/core';
import { ReportGenSvc, ReportTile, Role, RoleGenSvc } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-report-tile-defaults',
    templateUrl: './report-tile-defaults.component.html',
    styleUrls: ['./report-tile-defaults.component.css'],
    standalone: false
})
export class ReportTileDefaultsComponent implements OnInit {
  public allRoles: Role[];
  public allReportTiles: ReportTile[];

  public isLoading: boolean = true;

  constructor(private roleService: RoleGenSvc,
    private reportService: ReportGenSvc,
    
  ) { }

  ngOnInit() {
    this.reportService.getReportTiles().subscribe(tiles => {
      this.allReportTiles = tiles;

      this.roleService.getAll().subscribe(roles => {
        this.allRoles = roles.filter(role => role.id != 10);
        this.isLoading = false;
      });
    });
  }

}
